import React from 'react'
import { useTranslation } from 'react-i18next'
import LevelOneType from 'enums/LevelOneType'
import Sentiment from 'enums/Sentiment'
import Gender from 'enums/Gender'
import { WidgetGuard } from 'features/types'
import { DashboardWidget } from 'features/widget/types'
import { SocialWebStoryScopeWidget } from 'schemas/SocialWebStoryScopeWidgetSchema'
import { InsightCount } from 'schemas/action/InsightCountSchema'
import ErrorMessage from 'components/share/ErrorMessage'
import { useDashboardWidgetData } from 'hooks/useWidgetState'
import { useDashboardWidgetSetting } from 'hooks/useDashboardState'
import stripData from './utils/stripData'

const isResultBelowThreshold = (
  widgetData: DashboardWidget<InsightCount>,
  widgetSetting: SocialWebStoryScopeWidget
) => {
  const { minCount } = widgetSetting
  const innerDataSet = widgetData.data![0].results![0].data.insights![0].dataset![0].set

  switch (widgetSetting.levelOneType) {
    case LevelOneType.NONE:
    case LevelOneType.SENTIMENT:
      return innerDataSet!.every((item) => item.value! < minCount!)

    case LevelOneType.SENTIMENT_WO_NEUTRAL:
      return stripData(innerDataSet!, Sentiment.NEUTRAL).every((item) => item.value! < minCount!)

    case LevelOneType.GENDER_WO_UNKNOWN:
      return stripData(innerDataSet!, Gender.UNKNOWN).every((item) => item.value! < minCount!)

    default:
      throw new Error(`Unknown Level One Type: ${widgetSetting.levelOneType}`)
  }
}

const ResultBelowThresholdGuard: WidgetGuard = ({ widgetId, children }) => {
  const widgetSetting = useDashboardWidgetSetting<SocialWebStoryScopeWidget>(widgetId)
  const widgetData = useDashboardWidgetData<InsightCount>(widgetId)
  const { t } = useTranslation()

  if (isResultBelowThreshold(widgetData, widgetSetting))
    return <ErrorMessage>{t('emptyBecauseLowCount')}</ErrorMessage>

  return children
}

export default ResultBelowThresholdGuard
